// extracted by mini-css-extract-plugin
export default {"jobDetailsOverView":"styles_jobDetailsOverView__9mlNh","seller":"styles_seller__zDAiK","img":"styles_img__SybbY","info":"styles_info__HbaVZ","product":"styles_product__VY96X"};